document.documentElement.classList.remove('no-js');
document.addEventListener('click', async (e) => {
  const toggle=e.target.closest('[data-menu-toggle]'); if(toggle){document.querySelector('[data-mobile-menu]')?.classList.toggle('is-open');return;}
  const megaToggle=e.target.closest('[data-mega-toggle]');
  if(megaToggle){
    const wrap=megaToggle.closest('[data-megamenu]');
    const willOpen=!wrap.classList.contains('is-open');
    document.querySelectorAll('[data-megamenu].is-open').forEach(w=>{w.classList.remove('is-open');w.querySelector('[data-mega-toggle]').setAttribute('aria-expanded','false');});
    if(willOpen){wrap.classList.add('is-open');megaToggle.setAttribute('aria-expanded','true');}
    return;
  }
  if(!e.target.closest('[data-megamenu]')){document.querySelectorAll('[data-megamenu].is-open').forEach(w=>{w.classList.remove('is-open');w.querySelector('[data-mega-toggle]').setAttribute('aria-expanded','false');});}
  const thumb=e.target.closest('[data-product-image]'); if(thumb){const main=document.querySelector('.product-main-image img'); if(main) main.src=thumb.dataset.productImage; return;}
  const form=e.target.closest('[data-quick-add]');
  if(form && e.target.closest('button')){e.preventDefault(); const btn=form.querySelector('button'); const old=btn.textContent; btn.disabled=true; btn.textContent='Agregando…'; try{const fd=new FormData(form); const res=await fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root+'cart/add.js' : '/cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}}); if(!res.ok) throw new Error(); const cart=await fetch('/cart.js').then(r=>r.json()); document.querySelectorAll('[data-cart-count]').forEach(x=>x.textContent=cart.item_count); btn.textContent='Agregado ✓'; setTimeout(()=>btn.textContent=old,1400);}catch(err){btn.textContent='Ver producto'; setTimeout(()=>location.href=form.closest('.product-card').querySelector('.product-card__title').href,500);}finally{setTimeout(()=>btn.disabled=false,1500);} }
});
const productJson=document.querySelector('[data-product-json]');
if(productJson){const variants=JSON.parse(productJson.textContent); const selects=[...document.querySelectorAll('[data-option-index]')]; const updateVariant=()=>{const opts=selects.map(s=>s.value); const v=variants.find(v=>v.options.every((o,i)=>o===opts[i])); if(v){document.querySelector('[data-variant-id]').value=v.id; const p=document.querySelector('[data-product-price]'); if(p) p.textContent=(v.price/100).toLocaleString('es-CL',{style:'currency',currency:'CLP',maximumFractionDigits:0});}}; selects.forEach(s=>s.addEventListener('change',updateVariant));}

/* --- scroll infinito en colecciones --- */
(function(){
  const sentinel = document.querySelector('[data-infinite-sentinel]');
  if(!sentinel) return;
  const grid = document.querySelector('[data-product-grid]');
  const loader = sentinel.querySelector('[data-infinite-loader]');
  let loading = false;

  const loadNext = async () => {
    const nextUrl = sentinel.dataset.nextUrl;
    if(!nextUrl || loading) return;
    loading = true;
    loader.hidden = false;
    try{
      const res = await fetch(nextUrl);
      if(!res.ok) throw new Error('network');
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = doc.querySelector('[data-product-grid]');
      const newSentinel = doc.querySelector('[data-infinite-sentinel]');
      if(newGrid){ grid.insertAdjacentHTML('beforeend', newGrid.innerHTML); }
      sentinel.dataset.nextUrl = (newSentinel && newSentinel.dataset.nextUrl) ? newSentinel.dataset.nextUrl : '';
      if(!sentinel.dataset.nextUrl){ observer.disconnect(); }
    }catch(err){
      /* si falla, no reintenta solo; el cliente puede recargar y seguirá viendo la paginación clásica sin JS */
    }finally{
      loading = false;
      loader.hidden = true;
    }
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => { if(entry.isIntersecting) loadNext(); });
  }, { rootMargin: '600px 0px' });

  observer.observe(sentinel);
})();
